import { createApp, onBeforeMount } from 'vue'
import { createPinia } from 'pinia'

import App from './components/App.vue'
import './index.css'
import 'material-icons/iconfont/material-icons.css'
import router from './router'


const pinia = createPinia()
 
// axios.defaults.baseURL = process.env.NODE_ENV === 'production'
//   ? 'https://seen-redux.onrender.com/'
//   : 'http://localhost:3000'

const app = createApp(App).use(pinia).use(router).mount('#app')


